module.exports = __webpack_public_path__ + "static/img/dcode2.c4d3a0a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/dcode2.jpg
// module id = wBHp
// module chunks = 1